import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const CloseRoundedIcon = (props) => (React__default.createElement(SvgIcon, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "21", fill: "none", viewBox: "0 0 20 21" }, props),
    React__default.createElement("path", { fill: "#fff", d: "M0 0H20V20H0z", transform: "translate(0 .728)", style: { mixBlendMode: 'multiply' } }),
    React__default.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", d: "M5.042 5.813l9.916 9.829M14.914 5.77l-9.828 9.916" })));

export { CloseRoundedIcon };
